import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Avatar, Grid, Chip, Paper, Accordion, AccordionDetails, AccordionSummary, Container } from '@material-ui/core';
import { Code, ExpandMore } from '@material-ui/icons'

export const Team = () => {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(false);
    const [chipData, setChipData] = React.useState([
        { key: 0, label: 'Node' },
        { key: 1, label: 'Express' },
        { key: 2, label: 'Firebase' },
        { key: 3, label: 'MongoDb' },
        { key: 4, label: 'SQL' },
    ]);


    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Container maxWidth='md' disableGutters className={classes.root}>

<Typography variant="h5" align="left" color="textPrimary" gutterBottom>
                Team
                
            </Typography>
        <Grid container >

            <Grid item xs={12} md={6} >
                <Grid container justify='center' >

                    <Avatar alt="Remy Sharp" src="https://source.unsplash.com/random" className={classes.large} />
                </Grid>
            </Grid>
            <Grid item xs={12} md={6} className={classes.accd}>
                <Grid container justify='center'>

                    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <Typography className={classes.heading} component='div'>
                                <Avatar alt="Remy Sharp" src="https://source.unsplash.com/random" />


                            </Typography>
                            <Typography className={classes.secondaryHeading}>Ehtisham Mubasher</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Paper component='ul' className={classes.chipRoot}>
                                <Chip
                                    icon={<Code />}
                                    variant="outlined"
                                    color="primary"
                                    label=':'
                                    clickable
                                />
                                {chipData.map(data => (
                                    <li key={data.key}>
                                        <Chip color='primary' clickable label={data.label} className={classes.chip} />
                                    </li>
                                ))}

                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                        >
                            <Typography className={classes.heading} component='div'>
                                <Avatar alt="Remy Sharp" src="https://source.unsplash.com/random" />
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                Abaid ullah
          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Paper component='ul' className={classes.chipRoot}>
                                <Chip
                                    icon={<Code />}
                                    variant="outlined"
                                    color="primary"
                                    label=':'
                                    clickable
                                />
                                {chipData.map(data => (
                                    <li key={data.key}>
                                        <Chip color='primary' clickable label={data.label} className={classes.chip} />
                                    </li>
                                ))}

                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel3bh-content"
                            id="panel3bh-header"
                        >
                            <Typography className={classes.heading} component='div'>
                                <Avatar alt="Remy Sharp" src="https://source.unsplash.com/random" />
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                Faraz
          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Paper component='ul' className={classes.chipRoot}>
                                <Chip
                                    icon={<Code />}
                                    variant="outlined"
                                    color="primary"
                                    label=':'
                                    clickable
                                />
                                {chipData.map(data => (
                                    <li key={data.key}>
                                        <Chip color='primary' clickable label={data.label} className={classes.chip} />
                                    </li>
                                ))}

                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel4bh-content"
                            id="panel4bh-header"
                        >
                            <Typography className={classes.heading} component='div'>
                                <Avatar alt="Remy Sharp" src="https://source.unsplash.com/random" />
                            </Typography>
                            <Typography className={classes.secondaryHeading}>
                                Team
          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Paper component='ul' className={classes.chipRoot}>
                                <Chip
                                    icon={<Code />}
                                    variant="outlined"
                                    color="primary"
                                    label=':'
                                    clickable
                                />
                                {chipData.map(data => (
                                    <li key={data.key}>
                                        <Chip color='primary' clickable label={data.label} className={classes.chip} />
                                    </li>
                                ))}

                            </Paper>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>


        </Grid>
        </Container>

    );
}

const useStyles = makeStyles((theme) => ({
    chipRoot: {
        display: 'flex',
        justifyContent: 'space-around',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        // margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5),
    },

    
    root: {
        // width: '100%',
        minHeight:'50vh'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
        padding: theme.spacing(1, 5, 1, 0)
    },
    large: {
        width: theme.spacing(35),
        height: theme.spacing(35),

    },

}));